import Api from '../Api'
import { GlobalsResponse } from '../types/globals'

export async function getGlobals(url): Promise<GlobalsResponse> {
  const response = await Api.get(url)
  return response.data
}
